//Library
//TODO - refactoring this page into simPROMaps.js or turn this page into generic class as one page may have multiple map objects (perhaps in different tab views) and one static map object is not suit for future requirements
var mapsHolder = []

var simproMap;
var simproMapManager;
var geocoder = null;
var router;
var circleObjs = {};
var circleRadius = {};
var circleMarkerObjs = {};
var markerObjs = {};
var infoWinObjs = {};
var mapCenter = {};
var legendData = {};
var loadingLegendData = [];
var reCenterMap = false;
var bounds;
var distanceMarkersArray = [];
var distanceMarkersDataArray = [];
var distanceInfoWindows = [];
var employeeChkArray = [];
var destList = [];
var origList = [];
var mapScroll = true;

var mapContainerID = "";
var customMapOptions = {};
var circlesData = {};
var markersData = {};
var vehiclesData = {};

var cachedDistances = [];

var queryLimit = 24; // number of tec #24 + origin #1 total #25
var markerDelay = 100;
var currentMarkerDelay = 0;

var calcNotPossible = gettext('Distance calculation not possible.');
var notCalculated = gettext('Distance not yet calculated.');
var limitExceeded = gettext('As there are more than ' + queryLimit + ' techs available, only the first ' + queryLimit + ' have been calculated.');
var noSite = gettext('Distance calculation not possible. No site address available.');
var noAddress = gettext('Distance calculation not possible. No valid address available.');
var noRoute = gettext(
  'Distance calculation not possible. No route could be found between the origin and destination.');
var geocodingFailed = gettext(
  'Distance calculation not possible. Origin and/or destination of this pairing could not be geocoded.');
var queryTimeExceeded = gettext(
  'Distance calculation not possible. Maximum amount of distance queries exceeded within allowed time period.');
var queryExceeded = gettext(
  'Distance calculation not possible. Maximum amount of distance queries exceeded.');

var countriesCache = [
  {
    country: "Australia",
    zoom: 4,
    geometry: {
      location: {
        lat: -24.7761086,
        lng: 134.755
      },
      viewport: {
        northeast: {
          lat: -17.2761086,
          lng: 142.255
        },
        southwest: {
          lat: -32.2761086,
          lng: 127.255
        }
      }
    }
  },
  {
    country: "United Kingdom",
    zoom: 6,
    geometry: {
      location: {
        lat: 54.7023545,
        lng: -3.2765753
      },
      viewport: {
        northeast: {
          lat: 60.45721779774397,
          lng: 8.130446334352943
        },
        southwest: {
          lat: 46.195042108660154,
          lng: -17.57756147814706
        }
      }
    }
  },
  {
    country: "New Zealand",
    zoom: 6,
    geometry: {
      location: {
        lat: -41.5000831,
        lng: 172.8344077
      },
      viewport: {
        northeast: {
          lat: -32.43561304116276,
          lng: 183.91634538963987
        },
        southwest: {
          lat: -50.37349614430351,
          lng: 158.2083375771399
        }
      }
    }
  },
  {
    country: "United States",
    zoom: 4,
    geometry: {
      location: {
        lat: 39.7837304,
        lng: -100.4458825
      },
      viewport: {
        northeast: {
          lat: 56.46249048388979,
          lng: -73.83379778665312
        },
        southwest: {
          lat: 19.973348786110613,
          lng: -125.24981341165312
        }
      }
    }
  }, {
    country: 'Canada',
    zoom: 4,
    geometry: {
      location: {
        lat: 61.3140579,
        lng: -108.5050371
      },
      viewport: {
        northeast: {
          lat: 63.5511048,
          lng: -92.6471525
        },
        southwest: {
          lat: 51.93794965,
          lng: -124.59521870348149
        }
      }
    }
  }, {
    country: 'Singapore',
    zoom: 10,
    geometry: {
      location: {
        lat: 1.357236208361221,
        lng: 103.81937656460512
      },
      viewport: {
        northeast: {
          lat: 1.4201384,
          lng: 104.0707274
        },
        southwest: {
          lat: 1.2293247757109431,
          lng: 103.61485884025531
        }
      }
    }
  }, {
    country: 'Netherlands',
    zoom: 6,
    geometry: {
      location: {
        lat: 52.2434894,
        lng: 5.6343011
      },
      viewport: {
        northeast: {
          lat: 53.1983394,
          lng: 7.0833842
        },
        southwest: {
          lat: 51.5342888,
          lng: 3.4867042
        }
      }
    }
  }, {
    country: 'Ireland',
    zoom: 6,
    geometry: {
      location: {
        lat: 52.866992800000006,
        lng: -7.977903154838929
      },
      viewport: {
        northeast: {
          lat: 55.04275330431033,
          lng: -6.126856213046515
        },
        southwest: {
          lat: 51.871200599999995,
          lng: -10.143005658203617
        }
      }
    }
  }, {
    country: 'Fiji',
    zoom: 8,
    geometry: {
      location: {
        lat: -17.205091,
        lng: 178.696558
      },
      viewport: {
        northeast: {
          lat: -15.996984,
          lng: -179.394567
        },
        southwest: {
          lat: -18.405361,
          lng: 176.740992
        }
      }
    }
  }
];

function getCountryMapData() {
  let country = simPRODefaults.data("country");
  for (let i=0; i < countriesCache.length; i++) {
      if (countriesCache[i].country === country) {
        return countriesCache[i];
      }
  }
  return null;
}

function getGeocoder() {
  if (geocoder === null) {
    let geocodingKey = simPRODefaults.data("geocoding-key");
    let geocodingProvider = simPRODefaults.data("geocoding-provider");
    let timezone = simPRODefaults.data('timezone');
    geocoder = new simPROGeocoder({ key: geocodingKey, provider: geocodingProvider, timezone: timezone });
  }
  return geocoder;
}
function renderMap() {
  clearMarkers();
  var mapOptions = {};
  var hasMarker = false;
  var hideLoader = true;
  //Center
  if (typeof (customMapOptions["center"]) !== 'undefined') {
    mapOptions["center"] = createLatLng(customMapOptions["center"].lat,
      customMapOptions["center"].lon);
    mapCenter = mapOptions["center"];
  } else {
    // Center map based on Circles and Markers
    reCenterMap = true;
    mapOptions["center"] = createLatLng(0, 0);
  }
  //Zoom
  if (typeof (customMapOptions["zoom"]) !== 'undefined') {
    mapOptions["zoom"] = customMapOptions["zoom"];
  } else {
    mapOptions["zoom"] = 15;
  }
  mapOptions['enableSatelliteView'] = true;
  //mapOptions["scrollwheel"] = mapScroll;

  let geocodingKey = simPRODefaults.data("geocoding-key");
  let geocodingProvider = simPRODefaults.data("geocoding-provider");
  let geocodingSupKey = simPRODefaults.data("geocoding-sup-key");
  let geocodingSupProvider = simPRODefaults.data("geocoding-sup-provider");

  //Creating map
  simproMapManager = new simPROMaps({
    key: geocodingKey,
    provider: geocodingProvider,
    supKey: geocodingSupKey,
    supProvider: geocodingSupProvider
  });
  simproMap = simproMapManager.createMap(mapContainerID, mapOptions);

  mapsHolder[mapContainerID]=simproMapManager;

  $('#' + mapContainerID).css('background', '#e7e9ec');

  //Creating geocoder
  geocoder = getGeocoder();

  //Circles
  if (typeof (circlesData) !== 'undefined' && circlesData !== null) {
    for (var circleID in circlesData) {
      hasMarker = true;
      if (typeof (circlesData[circleID].show) !== 'undefined') {
        if (!circlesData[circleID].show) {
          circleMap = null;
        }
      }

      if (circlesData[circleID].lat === null || circlesData[circleID].lon === null) {
        //No center
        continue;
      }

      var circleOptions = {
        color: '#000000',
        opacity: 0.8,
        weight: 0.5,
        fillColor: circlesData[circleID].colour,
        fillOpacity: 0.35,
        radius: circlesData[circleID].accuracy
      };
      let latlon = createLatLng(circlesData[circleID].lat, circlesData[circleID].lon);

      // Adding the circle
      var Circle = simproMapManager.createCircle(latlon, circleOptions, map);
      circleObjs[circleID] = Circle;
      circleRadius[circleID] = circlesData[circleID].accuracy;

      if (typeof circlesData[circleID].profileIcon === 'undefined' || !circlesData[circleID].profileIcon.length) {
          var empIcon = simproMapManager.createIconFromUrl('/versions/' + simPRODefaults.data(
            "build-version") + '/public/images/icon_google_maps_location_tech.png');
      } else {
          var backGroundImageCSS = ' style="background-image: url(\'' + circlesData[circleID].profileIcon + '\')"';
          var empIcon = L.divIcon({
              html:'<div class="empMarkerIconPin"' + backGroundImageCSS + '></div>',
          });
      }
      let markerIcon = empIcon;

      let infoWindow = new L.popup({offset: [1,-29]});
      if (circlesData[circleID].circleInfoPopup != undefined && circlesData[circleID].circleInfoPopup) {
        let hyperlinkUrl = ((circlesData[circleID].isQuote == 1) ? '/staff/editProject.php?quoteID=' : '/staff/editProject.php?jobID=') + circlesData[circleID].projectID;
        var contentInfoWindow =
          '<div class="googleMapInfoWindow">' +
          '<h3>' + circlesData[circleID].title + '</h3>' +
          '<p><b>' +
          '<a href="' + hyperlinkUrl + '" target="_blank">' + circlesData[circleID].projectTitle + '</a> - ' + circlesData[circleID].status +
          '</b></p>' +
          '<p>' +
          circlesData[circleID].date + ' - ' +
          circlesData[circleID].time + '<br />' +
          '</p>' +
          '</div>';

        infoWindow.setContent(contentInfoWindow);
        infoWindow.setLatLng(latlon);
      } else {
        infoWindow = null;
      }

      // Add the circle marker
      var CircleMarker = simproMapManager.createMarker(latlon,
        markerIcon,
        infoWindow,
        null,
        null,
        simproMap);
      circleMarkerObjs[circleID] = CircleMarker;

    }
  }

  //Markers
  if (typeof (markersData) !== 'undefined' && markersData !== null) {
    var legendId = 1;
    for (var markerID in markersData) {
      hasMarker = true;
      hideLoader = false;
      //Get position of marker based on address if no position
      if (typeof (markersData[markerID].lat) === 'undefined' || typeof (markersData[markerID].lon) === 'undefined') {
        if (typeof (markersData[markerID].siteAddress) === "string" && markersData[markerID].siteAddress !== "") {
          loadingLegendData.push(markerID);
          var address = markersData[markerID].siteAddress;
          // Without self executing closure, only last values in the loop will be shared to timers' handlers
          // Ref: https://stackoverflow.com/questions/19714453/calling-settimeout-in-a-loop-not-working-as-expected
          (function (markerID,address,legendId) {
            setTimeout(function () {
              addMarkerAddress(markerID, address, legendId)
            }, currentMarkerDelay);
          }(markerID,address,legendId));
          currentMarkerDelay += markerDelay;
        } else {
          //No address so no way to determine center
          continue;
        }
      } else {
        addMarker(markerID, legendId);
      }
      legendId++;
    }

    renderLegend();
  }

  if (typeof (vehiclesData) !== 'undefined' && vehiclesData !== null) {
    for (let index in vehiclesData) {
      var vehicleData = vehiclesData[index];
      if (vehicleData.latitude != null && vehicleData.longitude != null) {
        addVehicleMarker(vehicleData);
      }
    }
  }

  if (reCenterMap) {
    centerMap();
  }
}

function reloadMapMarkers() {
    clearMarkers();
    let hasMarker = false;

    // Circles
    if (typeof (circlesData) !== 'undefined' && circlesData !== null) {
        for (const circleID in circlesData) {
            if (typeof (circlesData[circleID].show) !== 'undefined') {
                // Check if circle data options is checked
                const circleChecked = $('.chk' + circleID).is(':checked');
                if (!circlesData[circleID].show || !circleChecked) {
                    // Circle data not ticked or circle data set to not show, skip processing this circle data
                    continue;
                }
            }

        if (circlesData[circleID].lat === null || circlesData[circleID].lon === null) {
            //No center, skip processing this circle marker
            continue;
        }
        hasMarker = true;

        const circleOptions = {
            color: '#000000',
            opacity: 0.8,
            weight: 0.5,
            fillColor: circlesData[circleID].colour,
            fillOpacity: 0.35,
            radius: circlesData[circleID].accuracy
        };
        const latlon = createLatLng(circlesData[circleID].lat, circlesData[circleID].lon);

        // Adding the circle
        const Circle = simproMapManager.createCircle(latlon, circleOptions, map);
        circleObjs[circleID] = Circle;
        circleRadius[circleID] = circlesData[circleID].accuracy;

        let empIcon;
        if (typeof circlesData[circleID].profileIcon === 'undefined' || !circlesData[circleID].profileIcon.length) {
            empIcon = simproMapManager.createIconFromUrl(
                '/versions/' + simPRODefaults.data("build-version") + '/public/images/icon_google_maps_location_tech.png'
            );
        } else {
            const backGroundImageCSS = ' style="background-image: url(\'' + circlesData[circleID].profileIcon + '\')"';
            empIcon = L.divIcon({
                html:'<div class="empMarkerIconPin"' + backGroundImageCSS + '></div>',
            });
        }
        const markerIcon = empIcon;

        let infoWindow = new L.popup({ offset: [1, -29] });
        if (circlesData[circleID].circleInfoPopup !== undefined && circlesData[circleID].circleInfoPopup) {
            const hyperlinkUrl = ((circlesData[circleID].isQuote === 1) ? '/staff/editProject.php?quoteID=' : '/staff/editProject.php?jobID=') + circlesData[circleID].projectID;
            var contentInfoWindow =
                '<div class="googleMapInfoWindow">' +
                    '<h3>' + circlesData[circleID].title + '</h3>' +
                    '<p><b><a href="' + hyperlinkUrl + '" target="_blank">' + circlesData[circleID].projectTitle + '</a> - ' + circlesData[circleID].status + '</b></p>' +
                    '<p>' + circlesData[circleID].date + ' - ' + circlesData[circleID].time + '<br /></p>' +
                '</div>';

            infoWindow.setContent(contentInfoWindow);
            infoWindow.setLatLng(latlon);
        } else {
            infoWindow = null;
        }

            // Add the circle marker
            const CircleMarker = simproMapManager.createMarker(latlon, markerIcon, infoWindow, null, null, simproMap);
            circleMarkerObjs[circleID] = CircleMarker;
        }
    }

    // Markers
    if (typeof (markersData) !== 'undefined' && markersData !== null) {
        let legendId = 1;
        for (const markerID in markersData) {
            // Get position of marker based on address if no lat/long defined
            if (typeof (markersData[markerID].lat) === 'undefined' || typeof (markersData[markerID].lon) === 'undefined') {
                if (typeof (markersData[markerID].siteAddress) === "string" && markersData[markerID].siteAddress !== "") {
                    loadingLegendData.push(markerID);
                    const address = markersData[markerID].siteAddress;
                    addMarkerAddress(markerID, address, legendId);
                    hasMarker = true;
                } else {
                    // No address or coordinates so no way to determine position. Skip.
                    continue;
                }
            } else {
                addMarker(markerID, legendId);
                hasMarker = true;
            }
            legendId++;
        }
        renderLegend();
    }

    if (!hasMarker) {
        // No markers to load, center map based on country
        centerMap();
    }
}

function clearMarkers() {
  for (var id in circleObjs) {
    circleObjs[id].remove();
  }

  for (var id in circleMarkerObjs) {
    circleMarkerObjs[id].remove();
  }

  for (var id in markerObjs) {
    markerObjs[id].remove();
  }

  for (var id in infoWinObjs) {
    infoWinObjs[id].remove();
  }

  circleObjs = {};
  circleMarkerObjs = {};
  markerObjs = {};
  infoWinObjs = {};
}

function toggleMapElement(id, type) {
  var elements = Array();
  if (type === "circle") {
    //Circle
    let element = circleObjs[id];
    elements.push(element);

    //Marker
    element = circleMarkerObjs[id];
    elements.push(element);
  } else {
    let element = markerObjs[id];
    elements.push(element);
  }

  let reCenter = false;
  for (var i = 0; i < elements.length; i++) {
    let element = elements[i];
    if (typeof (element) !== 'undefined') {
      if (simproMap.hasLayer(element)) {
        element.remove();
      } else {
        element.addTo(simproMap);
      }
      reCenter = true;
    }
  }

  if (reCenter) {
    centerMap();
  }
}

function createLatLng(lat, lon) {
  return L.latLng(lat, lon);
}

function centerMap(points) {
  var bounds = new L.latLngBounds();
  var countMarkers = 0;

  if (!points) {
    //Circles
    if (Object.getOwnPropertyNames(circleObjs).length !== 0) {
      for (var circleID in circleObjs) {
        if (simproMap.hasLayer(circleObjs[circleID])) {
          let circleBounds = circleObjs[circleID].getBounds();
          bounds.extend(circleBounds.getNorthEast());
          bounds.extend(circleBounds.getSouthWest());
          countMarkers++;
        }
      }
    }
    //Markers
    if (Object.getOwnPropertyNames(markerObjs).length !== 0) {
      for (let markerID in markerObjs) {
        if (simproMap.hasLayer(markerObjs[markerID]) ) {
          bounds.extend(markerObjs[markerID].getLatLng());
          countMarkers++;
        }
      }
    }
  } else {
    doCentre = true;
    for (var id in points) {
      var point = points[id];
      if (point.type === "circle") {
        if (simproMap.hasLayer(point.element)) {
          var circleBounds = point.element.getBounds();
          bounds.extend(circleBounds.getNorthEast());
          bounds.extend(circleBounds.getSouthWest());
          countMarkers++;
        }
      } else {
        if (simproMap.hasLayer(point.element)) {
          bounds.extend(point.element.getLatLng());
          countMarkers++;
        }
      }
    }
  }

  if (countMarkers == 0) {
    bounds = countryCenter(bounds);
  } else if (simproMap.getZoom() > 18 || countMarkers == 1) {
    simproMap.fitBounds(bounds);
    simproMap.setZoom(18);
  } else {
    simproMap.fitBounds(bounds);
  }
}

function countryCenter(origBounds) {
  let countryData = getCountryMapData();
  if (countryData !== null) {
      let corner1 = L.latLng(countryData.geometry.viewport.northeast),
          corner2 = L.latLng(countryData.geometry.viewport.southwest),
          bounds = L.latLngBounds(corner1, corner2);

      simproMap.setView(countryData.geometry.location, countryData.zoom);
      return bounds;
  }
  let country = simPRODefaults.data("country");
  geocoder.geocode(country,function (results, status) {
    if (status == 'OK') {

      let corner1 = L.latLng(results[0].geometry.viewport.northeast),
        corner2 = L.latLng(results[0].geometry.viewport.southwest),
        bounds = L.latLngBounds(corner1, corner2);

      simproMap.fitBounds(bounds);
      simproMap.setZoom(4);
      return bounds;
    }
  });

  return origBounds;
}

function addVehicleMarker(vehicleData) {
  var latLng = L.latLng(vehicleData.latitude, vehicleData.longitude);
  var direction = vehicleData.direction;
  let markerIcon = getIcon(direction, vehicleData.currentStatus);
  var infoWindow = new L.popup({offset: [1,-29]});
  var accText = vehicleData.currentStatus ? "ON" : "OFF";
  var location = vehicleData.location !== null && vehicleData.location !== "" ? vehicleData.location : ''
  if (vehicleData.currentStatus) {
    location +=  "In Transit (Current Speed: " + vehicleData.speed + ")";
  }
  var contentInfoWindow =
      '<div class="googleMapInfoWindow">' +
      '<h3>Vehicle #' + vehicleData.vehicleId + '</h3>' +
      '<p>Vehicle Name: ' + vehicleData.vehicleName + '<br />' +
      'Driver: ' + vehicleData.driverName + '<br />' +
      'Last Update: ' + vehicleData.lastUpdate + '<br />' +
      'Current Status: ' + accText + " (" + vehicleData.statusSwitch + ")" + '<br />' +
      'Location: ' + location + '<br />' +
      'Registration: ' + vehicleData.registration +
      '</p>' +
      '</div>';
  infoWindow.setContent(contentInfoWindow);
  markerObjs[vehicleData.vehicle_id] = simproMapManager.createMarker(latLng,
      markerIcon,
      infoWindow,
      null,
      null,
      simproMap);
}

function getIcon(orientation, statusAcc) {
  var imgNumber, layer, scale;
  scale = 1;
  layer = 0;
  if (!statusAcc) {
    layer += 2;
  }
  imgNumber = Math.round(orientation / 22) % 16;
  var left = -imgNumber * 26 * scale;
  var top = -layer * 30 * scale;
  var height = 120 * scale;
  var width = 416 * scale;
  var iconCss = "position: absolute; left: " + left + "px ; " +
      "top:" + top + "px; height:" + height + "px; " +
      "width:"+ width + "px; user-select: none; border: 0px; " +
      "padding: 0px; margin: 0px; max-width: none; opacity: 1;" ;
  var iconSrc = '/versions/' + simPRODefaults.data( "build-version") + '/public/images/marker.png';
  return L.divIcon({
    html: '<img alt src=' + iconSrc + ' draggable="false" style="' + iconCss + '">',
    iconSize: [Math.floor(26 * scale), Math.floor(30 * scale)],
    iconAnchor: [Math.floor(13 * scale), Math.floor(30 * scale)],
    className: "leaflet-div-icon leaflet-marker-vehicle"
  });

}

function addMarker(markerID, legendId) {
  if (markerObjs[markerID] == undefined) {
    //Add Legend
    legendId = (markersData[markerID].title == gettext('Job Site')) ? gettext('Site') : legendId;
    legendData[markerID] = {
      id: legendId,
      title: markersData[markerID].title,
      colour: markersData[markerID].colour,
      show: true
    };

    if (typeof (markersData[markerID].position) === 'undefined' || markersData[markerID].position == null) {
      legendData[markerID].show = false;
      return false;
    }

    let markerIcon = simproMapManager.createIconFromUrl(getMapJobsToolsPath() + '/marker.php?color=' + markersData[markerID].colour + '&text=' + legendId);
    let infoWindow = new L.popup({offset: [1,-29]});

    //Info Windows
    if (markersData[markerID].status != undefined && markersData[markerID].date != undefined) {
      var hyperlinkUrl = ((markersData[markerID].isQuote == 1) ? '/staff/editProject.php?quoteID=' : '/staff/editProject.php?jobID=') + markersData[markerID].projectID;
      var contentInfoWindow =
        '<div class="googleMapInfoWindow">' +
        '<h3>' + markersData[markerID].title + '</h3>' +
        '<p><b>' +
        '<a href="' + hyperlinkUrl + '" target="_blank">' + markersData[markerID].projectTitle + '</a> - ' + markersData[markerID].status +
        '</b></p>' +
        '<p>' +
        markersData[markerID].date + ' - ' +
        markersData[markerID].time + '<br />' +
        '</p>' +
        '</div>';
    } else {
      var contentInfoWindow =
        '<div class="googleMapInfoWindow">' +
        '<h3>' + markersData[markerID].title + '</h3>' +
        '<p><b>Customer</b><br />' +
        markersData[markerID].customerName + '<br />' +
        markersData[markerID].customerPhone + '<br />' +
        markersData[markerID].customerEmail +
        '</p>' +
        '<p><b>Site</b><br />' +
        markersData[markerID].siteName + '<br />' +
        markersData[markerID].sitePhone + '<br />' +
        markersData[markerID].siteAddress +
        '</p>' +
        '</div>';
    }
    infoWindow.setContent(contentInfoWindow);
    infoWindow.setLatLng(markersData[markerID].position);

    // Add the marker
    var Marker = simproMapManager.createMarker(markersData[markerID].position,
      markerIcon,
      infoWindow,
      null,
      null,
      simproMap);
    markerObjs[markerID] = Marker;
    infoWinObjs[markerID] = infoWindow;

    centerMap();
  }
}

function addMarkerAddress(markerID, address, legendId) {
  // TODO - MA-2438 cache the coordinates to reduce the amount of requests
  geocoder.geocode(address, function (result, status) {
    if (status === 'OK') {
      if (typeof result[0].geometry.location.lat === 'undefined' || typeof result[0].geometry.location.lng === 'undefined') {
        console.log(markerID + ": address : '" + decodeURIComponent(address) + "' not found");
      } else {
        markersData[markerID].position = createLatLng(result[0].geometry.location.lat, result[0].geometry.location.lng);
      }
      addMarkerAndLegend();

    } else {
      if (typeof result.responseJSON === 'undefined') {
        console.log("Json parse error");
        addMarkerAndLegend()
      } else if (result.status !== 429) {
        //this is very unlikely to happen...
        //https://locationiq.com/docs-html/index.html#errors
        console.log(markerID + ": address : '" + decodeURIComponent(address) + "' not found");
        console.log(result.status + ": " + result.responseText);
        addMarkerAndLegend()
      }
   }

    function addMarkerAndLegend() {
      //Same as previous code - add legendID into legendData even has no position data
      //In addMarker(), makers will not show on map if no position data
      addMarker(markerID, legendId);

      var pos = loadingLegendData.indexOf(markerID);
      //check negative in case it removes last one
      if (pos > -1) {
        loadingLegendData.splice(pos, 1);
      }
      renderLegend();
    }
  });
}

function goToPoint(id, type) {
  if (type === "circle") {
    var element = circleObjs[id];
  } else {
    var element = markerObjs[id];
  }
  if (typeof (element) !== 'undefined') {
    var points = {
      0: {
        "type": type,
        "element": element
      }
    };
    centerMap(points);
    $('html,body').animate({
        scrollTop: $("#" + mapContainerID).offset().top
      },
      'slow');
  }
}

function renderLegend() {
  if ($('.dashboardContent .map-container').length < 1) {
    if (Object.keys(legendData).length > 0 && Object.keys(markersData).length > 0 && loadingLegendData.length == 0) {
      for (var legendID in markersData) {
        var title = legendData[legendID].title;

        var checkBox = "<input type='checkbox' onclick='toggleMapElement(\"" + legendID + "\", \"marker\")' checked='checked' />";
        var goToPoint = "<span class=\"googleMapLocationIcon icon-search\" onclick='goToPoint(\"" + legendID + "\", \"marker\")' title='Show position'></span>";
        if (!legendData[legendID].show) {
          title = "<span style='text-decoration: line-through;'>" + title + "</span>";
          checkBox = "<input type='checkbox' style='visibility: hidden;'/>";
          goToPoint = "<div class='googleMapLocationIcon' style='visibility: hidden;'></div>";
        }

        let legend = new SimPROLegend(legendData[legendID].id,
          title,
          legendData[legendID].colour,
          legendID);
        legend.addTo(simproMap);
      }

      var mapContainer = $("#" + mapContainerID);
      var legendBox = $('#googleMapLegend');

      if (legendBox.length <= 0) {
        mapContainer.after('<div class="googleMapLegend" id="googleMapLegend"></div>');
        legendBox = $('#googleMapLegend');
      }

      $(".googleMapLegend").show("fast", function () {
        $(".googleMapLoading").fadeOut("fast");
      });
    }
  }
}

function matrixInitialize() {
  var distanceMap = $("#distanceMap");
  let geocodingKey = simPRODefaults.data("geocoding-key");
  let geocodingProvider = simPRODefaults.data("geocoding-provider");
  let geocodingSupKey = simPRODefaults.data("geocoding-sup-key");
  let geocodingSupProvider = simPRODefaults.data("geocoding-sup-provider");

  if (distanceMap.exists()) {
    if (!distanceMap.hasClass("doneInit")) {
      distanceMap.addClass("doneInit");

      try { // for IE 10
        bounds = new L.latLngBounds();
      }
      catch (err) {
        // nothing
      }
      try { // for IE 10
        geocoder = getGeocoder();

        var opts = {
          zoom: 10,
          enableSatelliteView: true
        };

        simproMapManager = new simPROMaps({
          key: geocodingKey,
          provider: geocodingProvider,
          supKey: geocodingSupKey,
          supProvider: geocodingSupProvider
        });
        simproMap = simproMapManager.createMap('distanceMap', opts);

        geocoder.geocode(simPRODefaults.data("country"),
          function (results, status) {
            if (status == 'OK') {
              simproMap.flyTo(results[0].geometry.location, 4);
            }
          });
      }
      catch (err) {
        console.log(err);
        return false;
      }
    }
    return true;
  }
  return false;
}

function checkLocationValid(loc) {
  loc = loc.replace(' ', '');
  locArr = loc.split(',');

  if (locArr[0].trim().length == 0) {
    return false;
  }

  return true;
}

function timeZoneIsEurope(timezone) {
  if (timezone.indexOf("Europe") != -1) {
    return true;
  }
  return false;
}

function getLocationIQServerLocale(timezone) {
  let serverLocale = 'us1';
  if (timeZoneIsEurope(timezone)) {
    serverLocale = 'eu1';
  }
  return serverLocale;
}

function calculateDistances() {
  var siteAddress = $('#siteDistanceAddress');
  var $this = $(this);
  // Let's make sure we're not doing too many calls, or calls for no reason.
  if (!siteAddress.exists()) {
    var alertDialog = createDialog("alert",
      gettext('Unable to perform distance calculation, no site selected.'),
      gettext('No Site Selected.'));
  } else if (siteAddress.val().trim() == '') {
    var alertDialog = createDialog("alert",
      gettext('Site address is not filled in.'),
      gettext('Site Address'));
  } else {
    matrixInitialize();
    clearOverlays();

    destList = Array();
    origList = Array();
    let site = {};
    site.address = siteAddress.val().trim();
    site.employeeID = 0;

    employeeChkArray = $('.scheduleEmployeesChk');
    for (i = 0; i < employeeChkArray.length; i++) {
      let empId = employeeChkArray[i].value + '_' + $(employeeChkArray[i]).closest('tr').data('key');
      let locSelect = $('#employeeLoc_' + empId);
      let location = locSelect.val();
      location = location.replace(/(\r\n|\n|\r)/gm, " ");//get rid of newlines
      let distanceDiv = $('#employeeDistance_' + empId)[0];

      if (checkLocationValid(location)) {
        var distanceSelect = $('#employeeDistance_' + empId);
        var distanceHtml = distanceSelect.html().trim();
        if (origList.length < queryLimit &&
          (distanceHtml == notCalculated
            || distanceHtml == limitExceeded
            || distanceHtml == noSite)) {
          let origin = {};
          origin.address = location;
          origin.employeeID = empId;
          origList.push(origin);
        }
      } else {
        distanceDiv.innerHTML = noAddress;
      }
    }

    if (site.address) {
      if (origList.length > 0) {
        origList.push(site);
        geocoder.batchGeocode(origList, batchGeocodeCallback);
      }
    } else {
      $('.employee-distance').html(noSite);
    }
  }
}

function batchGeocodeCallback(response, status, errors) {
  if (status !== 'OK') {
    console.log("Error while executing Batch Geocode");
    console.log(errors);
  }

  let geocodingKey = simPRODefaults.data("geocoding-key");
  let geocodingProvider = simPRODefaults.data("geocoding-provider");
  let timezone = simPRODefaults.data("timezone");

  // need to extract the jobsite
  let jobLocation = {};
  for( let i = 0; i < response.length; i++){
    if (response[i].id === 0) {
      jobLocation = response.splice(i, 1)[0];
    }
  }

  var router = new simPRORouter({ key: geocodingKey, provider: geocodingProvider, timezone: timezone });
  router.getDistanceMatrix(response, jobLocation, distanceMatrixCallback);

}

function distanceMatrixCallback(response, status) {
  if (status !== 'OK') {
    let employeeDistance = $('.employee-distance');
    if (status === 'MAX_ELEMENTS_EXCEEDED') {
      employeeDistance.html(queryExceeded);
      employeeDistance.css('color', '#d00');
    } else if (status === 'OVER_QUERY_LIMIT') {
      employeeDistance.html(queryTimeExceeded);
      employeeDistance.css('color', '#d00');
    } else {
      employeeDistance.html(calcNotPossible);
      employeeDistance.css('color', '#d00');
    }
  } else {
    clearOverlays();

    var destinations = response.pop();
    var origins = response;

    data = {
      location: destinations.geometry.location,
      title: destinations.formatted_address,
      colour: 'cccccc',
      legendId: 'Site',
    };

    addDistanceMarker(data);

    if (!cachedDistances[destList[0]]) {
      cachedDistances[destList[0]] = Array();
    }

    for (var i = 0; i < origins.length; i++) {
      var employeeID = origins[i].id;

      let color = $('#legendColor_' + employeeID).val();
      let tech = $('#techName_' + employeeID).html();
      let locTitle = $('#employeeLocName_' + employeeID).html();
      let originalAddress = $('#employeeLoc_' + employeeID).val();

      let unitSystem = simPRODefaults.data("country") === "United States" ? 'imperial' : 'metric';
      let formattedDistanceDuration = formatDistanceDuration(origins[i].distance[0], origins[i].duration[0], unitSystem);

      let data = {
        location: origins[i].geometry.location,
        locationTitle: locTitle,
        title: tech,
        colour: color,
        legendId: i+1,
        employeeID: employeeID,
        distanceDuration: formattedDistanceDuration.distance + ' / ' + formattedDistanceDuration.duration
      };

      addDistanceMarker(data);

      let distanceDiv = $('#employeeDistance_' + employeeID)[0];

      if (!cachedDistances[originalAddress]) {
        cachedDistances[originalAddress] = {
          distance: {
            duration: origins[i].duration[0],
            distance: origins[i].distance[0],
            duration_text: formattedDistanceDuration.duration,
            distance_text: formattedDistanceDuration.distance,
          },
          message: 'OK'
        };
      }

      $('#employeeTime_' + employeeID).val(origins[i].duration[0]);
      $('#employeeDist_' + employeeID).val(origins[i].distance[0]);
      distanceDiv.innerHTML = formattedDistanceDuration.distance + ' / ' + formattedDistanceDuration.duration;
    }
    renderDistanceLegend();
  }
  if(origins.length===queryLimit){
    $('.employee-distance:contains(' + notCalculated + ')').html(limitExceeded);
  }
  sortDistances();
}

function formatDistanceDuration(distance, duration, unitSystem) {
  if (unitSystem === 'imperial') {
    distance = parseFloat(distance / 1000 * 0.621371192).toFixed(2) + " mi";
  } else {
    distance = parseFloat(distance / 1000).toFixed(2) + " km";
  }

  let totalhours = Math.floor(duration / (3600));
  let totalMinutes = Math.floor(duration / 60) % 60;
  let time = "";
  if (totalhours > 0) {
    time = totalhours + " hr ";
  }
  time = time + totalMinutes + " min";

  return {
    distance: distance,
    duration: time
  };
}

function clearOverlays() {
  if (distanceMarkersArray.length > 0) {
    for (var id in distanceMarkersArray) {
      distanceMarkersArray[id].remove();
    }
    distanceMarkersArray = Array();
    distanceMarkersDataArray = Array();

    for (var id in distanceInfoWindows) {
      distanceInfoWindows[id].remove();
    }

    distanceInfoWindows = Array();
  }
}

function addDistanceMarker(markerData) {
  distanceMarkersDataArray[markerData.legendId] = markerData;

  if (typeof markerData.location.lat !== 'undefined' && typeof markerData.location.lng !== 'undefined') {

    let markerIcon = simproMapManager.createIconFromUrl(getMapJobsToolsPath() + '/marker.php?color=' + markerData.colour + '&text=' + markerData.legendId);
    let infoWindow = new L.popup({offset: [1,-29]});

    var contentInfoWindow =
      '<div class="googleMapInfoWindow">' +
      '<p><span class="fieldHeader marginTop">' + markerData.title + '</span></p>';
    if ('locationTitle' in markerData) {
      contentInfoWindow += '<p class="nowrap">' + markerData.locationTitle + '</p>';
    }
    if (markerData.legendId.toString() != 'Site') {
      contentInfoWindow += '<p class="nowrap">' + gettext('Distance from site') + ': ' +
        markerData.distanceDuration + '</p>';
    }
    contentInfoWindow += "</div>";

    infoWindow.setContent(contentInfoWindow);

    // Add the marker
    var Marker = simproMapManager.createMarker(
      markerData.location,
      markerIcon,
      infoWindow,
      null,
      null,
      simproMap);

    distanceMarkersArray[markerData.legendId] = Marker;
  }

  centerDistanceMap();
}

function centerDistanceMap() {
  var bounds = new L.latLngBounds();
  var countMarkers = 0;

  if (Object.getOwnPropertyNames(distanceMarkersArray).length !== 0) {
    for (let markerID in distanceMarkersArray) {
      let marker = distanceMarkersArray[markerID];
      if (simproMap.hasLayer(marker)) {
        bounds.extend(marker.getLatLng());
        countMarkers++;
      }
    }
  }

  if (countMarkers === 0) {
    bounds = countryCenter(bounds);
  } else {
    simproMap.fitBounds(bounds);
  }

 if (simproMap.getZoom() > 18 || countMarkers === 1) {
    simproMap.setZoom(18);
  }
}

function sortDistances() {
  alltimes = $('.employeeTime').parents('tr');
  tbody = $('.employeeTime').parents('tbody')[0];
  emptytimes = Array();
  calcedtimes = Array();
  calcedtimesAdded = Array();
  alltimes.find(".suggestSelect").suggestselect("destroy");
  for (i = 0; i < alltimes.length; i++) {
    val = $(alltimes[i]).find('.employeeTime').val();
    if (val != '') {
      var calT = $(alltimes[i]).wrap('<div>').parent().html();
      calcedtimes.push(calT);
    } else {
      var allT = $(alltimes[i]).wrap('<div>').parent().html();
      emptytimes.push(allT);
      // get id
      var empID = $(alltimes[i]).attr('empID') + '_' + $(alltimes[i]).data('key');
      var allTN = $('#employeeScheduledRow_' + empID).wrap('<div>').parent().html();
      emptytimes.push(allTN);
    }
  }

  calcedtimes.sort(function (a, b) {
    return sortOrder(a, b, true)
  });
  green = (calcedtimes.length > 2) ? 2 : calcedtimes.length;

  for (i = 0; i < calcedtimes.length; i++) {
    var calT = $(calcedtimes[i]);
    if (i < green) {
      calT.find('.employee-distance').css('color', '#5ba801');
    } else {
      calT.find('.employee-distance').css('color', '#000');
    }
    calT = calT.wrap('<div>').parent().html();
    calcedtimesAdded.push(calT);
    // get id
    var empID = $(calcedtimes[i]).attr('empID') + '_' + $(alltimes[i]).data('key');
    var calTN = $('#employeeScheduledRow_' + empID).wrap('<div>').parent().html();
    calcedtimesAdded.push(calTN);
  }
  $(tbody).html(calcedtimesAdded.concat(emptytimes));
  prepareDocument($(tbody));
  origList = Array();
}

function sortOrder(a, b, asc) {
  aVal = $(a).find('.employeeTime').val();
  bVal = $(b).find('.employeeTime').val();
  if (asc) {
    return aVal - bVal;
  } else {
    return bVal - aVal;
  }
}

function redrawMap() {
  simproMap.invalidateSize();
  showSite();
  centerDistanceMap();
}

function centerOnMarker(id) {
  if (typeof distanceMarkersArray[id] != 'undefined') {
    simproMap.flyTo(distanceMarkersArray[id].getLatLng(), 15, {duration: 0.5});
  }
}

function renderDistanceLegend() {
  if (distanceMarkersDataArray.length > 0) {
    var legendContent = "";

    for (var legendID in distanceMarkersDataArray) {
      var title = distanceMarkersDataArray[legendID]['title'];


      toCenter = isNaN(legendID) ? "'" + legendID + "'" : legendID;

      legendContent +=
        '<div class="googleMapDistanceLegendItem span4" onclick="centerOnMarker(' + toCenter + ')">' +
        '<div class="span2 googleMapLegendBoxWrap"><div class="left googleMapLegendBox" style="background-color: #' + distanceMarkersDataArray[legendID]['colour'] + ';">' + legendID + '</div></div>' +
        '<div class="span10 legendTitle">' + title + '</div>' +
        '</div>';
    }

    if ($(".googleMapDistanceLegend").length <= 0) {
      $("#distanceMap").before(
        '<div class="row"><div class="googleMapDistanceLegend span12" id="googleMapLegend"><div class="row"><div class="legendHeader span12"><span class="icon-up-arrow"></span>' +
        gettext('Legend') + '</div><div class="legendContent span12">' + legendContent + '</div></div></div>');
    }

    $(".googleMapDistanceLegend").show("fast", function () {
      $(".googleMapLoading").fadeOut("fast");
    });
  }
}

function showSite() {
  var siteLink = $('.site-link');
  if (siteLink.exists() && siteLink.html() != '') {
    destList = Array();
    destList.push(siteLink.html().trim());

    let colour = 'cccccc';
    let legendId = 'Site';

    // Regular expression to check if string is a latitude and longitude
    const coordinatesRegex = /^((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)$/gi;
    if (coordinatesRegex.test(destList[0])) {
      //Address is coordinates, do not call geocode and instead directly send the coordinates
      let siteCoordinates = destList[0].split(",");
      let siteLatitude = siteCoordinates[0];
      let siteLongitude = siteCoordinates[1];
      let data = {
        location: {
          lat: siteLatitude,
          lng: siteLongitude
        },
        title: destList[0],
        colour: colour,
        legendId: legendId
      };
      addDistanceMarker(data);
    } else {
      geocoder.geocode(destList[0], function (result) {
        let data = {
          location: result[0].geometry.location,
          title: result[0].formatted_address,
          colour: colour,
          legendId: legendId
        };
        addDistanceMarker(data);
      })
    }
    centerDistanceMap();
  }
}

$(document).on('click', '.legendHeader', function (e) {
  $('.legendContent').slideToggle();
  $('.legendHeader .icon-down-arrow, .legendHeader .icon-up-arrow')
  .toggleClass('icon-down-arrow')
  .toggleClass('icon-up-arrow');
});
